var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRarr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.707 11.7072L17.4141 6.00007L11.707 0.292969L10.2927 1.70718L13.5856 5.00006L-0.00012207 5.00006V7.00006L13.5856 7.00006L10.2927 10.293L11.707 11.7072Z",
    fill: "#192337"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRarr);
export default __webpack_public_path__ + "static/media/rarr.2d3858cd.svg";
export { ForwardRef as ReactComponent };